import { Group } from "modules/construction-work/src/Entity/IniData/Group";
import { IncidentMap } from "modules/construction-work/src/Entity/Work/IncidentMap";

export default class IncidentMapper {
    private groupMap: Map<number, Group>;

    constructor(groups: Group[]) {
        this.groupMap = new Map(groups.map(group => [group.id, group]));
    }

    build(item: {geoObject: string}): IncidentMap {
        const parseGeoObject = JSON.parse(item.geoObject);
        const feature = this.resolveFeature(parseGeoObject);
        const groupId = feature.properties?.groupId as number;
        const settingsMarker = this.groupMap.get(groupId);
        const { style, ...propertiesWithoutStyle } = feature.properties ?? {};
        return IncidentMap.createByObj({
            ...feature,
            properties: { ...propertiesWithoutStyle, settingsMarker }
        });
    }

    private resolveFeature(geo: any): any {
        if (geo.type === 'FeatureCollection') {
            return geo.features[0];
        } else {
            return geo;
        }
    }
}